<template>
  <div :class="{ 'aircraft-item-additional-info': true, 'mb-3': true, 'is-bigger': isBiggerLayout }">
    <small class="aircraft-item-additional-info-item">
      <strong>COFA:</strong>
      <span :class="{ 'text-warning': dateHasWarningState(aircraft.certificate_airworthiness), 'text-danger': dateHasDangerState(aircraft.certificate_airworthiness) }">
        {{ aircraft.certificate_airworthiness | dateShort }}
      </span>
    </small>

    <small class="aircraft-item-additional-info-item">
      <strong>INS:</strong>
      <span :class="{ 'text-warning': dateHasWarningState(aircraft.insurance), 'text-danger': dateHasDangerState(aircraft.insurance) }">
        {{ aircraft.insurance | dateShort }}
      </span>
    </small>

    <small class="aircraft-item-additional-info-item">
      <strong>RAD:</strong>
      <span :class="{ 'text-warning': dateHasWarningState(aircraft.radio_licence), 'text-danger': dateHasDangerState(aircraft.radio_licence) }">
        {{ aircraft.radio_licence | dateShort }}
      </span>
    </small>

    <small class="aircraft-item-additional-info-item">
      <strong>MAINT:</strong>
      <span :class="{ 'text-warning': dateHasWarningState(aircraft.maintenance), 'text-danger': dateHasDangerState(aircraft.maintenance) }">
        {{ aircraft.maintenance | dateShort }}
      </span>
    </small>

    <small
      v-if="aircraft.seats"
      class="aircraft-item-additional-info-item">
      <strong>Seats:</strong>
      <span>
        {{ aircraft.seats }}
      </span>
    </small>

    <small
      v-if="aircraft.mtow"
      class="aircraft-item-additional-info-item">
      <strong>MTOW:</strong>
      <span>
        {{ aircraft.mtow }} KG
      </span>
    </small>
  </div>
</template>

<script>
import DateUtils from './../../utils/DateUtils.js';

export default {
  name: 'aircraft-additional-info',
  props: [
    'aircraft',
    'isBiggerLayout'
  ],
  filters: {
    dateShort (input) {
      input = new Date(input);

      return [
        input.getDate(),
        DateUtils.getMonthShortName(input.getMonth() + 1),
        input.getFullYear().toString().substr(2, 2)
      ].map(n => n < 10 ? '0' + n : n).join('');
    }
  },
  methods: {
    dateHasWarningState (date) {
      date = +new Date(date);

      if (date - +new Date() < 7 * 24 * 60 * 60 * 1000) {
        return true;
      }

      return false;
    },
    dateHasDangerState (date) {
      date = +new Date(date);

      if (+new Date() > date) {
        return true;
      }

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.aircraft-item-additional-info {
  display: grid;
  font-size: 12px;
  line-height: 1.2;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 3px;
  grid-row-gap: 3px;
  margin-top: 5px;

  &-item {
    strong {
      display: inline-block;
      width: 32px;
    }
  }

  &.is-bigger {
    font-size: 18px;

    .aircraft-item-additional-info-item {
      strong {
        width: 48px;
      }
    }
  }
}
</style>
